module.exports = __webpack_public_path__ + "img/lamina1-primary.c27eee03.png";